import { ColumnDef } from "@tanstack/react-table"
import { UserStatus } from "~/__generated__/graphql"
import { Badge } from "~/ui/badge"
import { Button } from "~/ui/button"

export type UserColumns = {
  id: string
  fullName: string
  email?: string | null
  createdAt?: string | null
  userStatus: UserStatus
}

export type UserColumnsActions = {
  viewerId: string | null | undefined
  onSuspend: (id: string) => void
  onUnsuspend: (id: string) => void
  busy: boolean
}

export const makeColumns = (
  actions: UserColumnsActions
): ColumnDef<UserColumns | null | undefined>[] => [
  {
    accessorKey: "fullName",
    header: "Name",
    cell: ({ row }) => (
      <>
        <div className="text-sm">{row.getValue("fullName")}</div>
        <div className="text-gray-500">{row.original?.email}</div>
      </>
    ),
  },
  {
    accessorKey: "userStatus",
    header: "Status",
    cell: ({ row }) => {
      const status = row.original?.userStatus
      if (!status) return null
      const variant = status === "ACTIVE" ? "default" : "outline"
      return <Badge variant={variant}>{status}</Badge>
    },
  },
  {
    accessorKey: "createdAt",
    header: "Created at",
  },
  {
    id: "actions",
    header: "",
    cell: ({ row }) => {
      const u = row.original
      if (!u) return null
      const isSelf = actions.viewerId === u.id
      if (u.userStatus === "BLOCKED") {
        return (
          <Button
            variant="outline"
            size="sm"
            disabled={actions.busy}
            onClick={() => actions.onUnsuspend(u.id)}
          >
            Unsuspend
          </Button>
        )
      }
      return (
        <Button
          variant="ghost"
          size="sm"
          disabled={actions.busy || isSelf}
          onClick={() => actions.onSuspend(u.id)}
        >
          Suspend
        </Button>
      )
    },
  },
]
